var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "authentication_mode",
    label: "認証モード",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "C"
    },
  },
  {
    id: "permission_mode",
    label: "権限モード",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "D"
    },
  },
  {
    id: "ldap_host",
    label: "LDAPホスト",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "A"
    },
  },
  {
    id: "number_of_login_attempts",
    label: "ログイン試行回数",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "B"
    },
  },
  {
    id: "unlimited_account_lock_flag",
    label: "無制限アカウントロックフラグ",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "C"
    },
  },
  {
    id: "login_lock_time",
    label: "ログインロック時間（分）",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "D"
    },
  },
  {
    id: "password_expiration_date",
    label: "パスワード有効期限（日）",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "A"
    },
  },
  {
    id: "password_syntax",
    label: "パスワード構文（正規表現）",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "B"
    },
  },
  {
    id: "maximum_number_of_passwords",
    label: "パスワード最大値数",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "C"
    },
  },
  {
    id: "minimum_number_of_passwords",
    label: "パスワード最小値数",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "D"
    },
  },
  {
    id: "directory_to_be_viewed",
    label: "監視対象ディレクトリ（セミコロン区切り）",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "A"
    },
  },
  {
    id: "log_level",
    label: "ログレベル",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "C"
    },
  },
  {
    id: "log_cycle",
    label: "ログ周期",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "D"
    },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_system_setting.js